





































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import DialogConfirm from "@/components/DialogConfirm.vue";
import { Sorteo } from '@/model/Sorteo';
import { Filtro } from '@/model/Filtro';

@Component({
  components: {
    DialogConfirm
  }
})
export default class SorteoFiltrosPopup extends Vue {
  
  @Prop({ type: Boolean, default: false })
  visible: boolean = false;
  visibleConfirm: boolean = false;
  cancelEventConfirm: string ="EliminarFiltros-DialogConfirm-Cancel";
  acceptEventConfirm: string ="EliminarFiltros-DialogConfirm-Accept";

  valid: boolean = false;
  @Prop()
  filtro: any | Filtro;

  @Prop({ type: String, default: "FiltrosForm-Close" })
  nameEventClose: string | any;

  @Prop({ type: String, default: "FiltrosForm-Save" })
  nameEventSave: string | any;

  created() {
    eventService.on(this.cancelEventConfirm, (obj: any) => {
      this.visibleConfirm = false;
    });

    eventService.on(this.acceptEventConfirm, (obj: any) => {
      this.filtro.PrimeraCifra = "";
      this.filtro.SegundaCifra = "";
      this.filtro.TerceraCifra = "";
      this.filtro.CuartaCifra = "";
      this.filtro.QuintaCifra = "";

      this.filtro.StockDesde = -1;
      this.filtro.StockHasta = -1;
      this.filtro.MostrarPrimeroMayorStock = false;
      this.filtro.MostrarPrimeroMenorStock = false;

      this.filtro.TresOMasIguales = false;
      this.filtro.NoTresOMasIguales = false;

      this.visibleConfirm = false;

      eventService.emit("FiltrosForm-Save", this.filtro);
    });
  }

  destroyed(){
    eventService.off(this.cancelEventConfirm);
    eventService.off(this.acceptEventConfirm);
  }

  close() {
    logService.Info("Inicio","SorteoFiltrosPopup.vue - close()");
    eventService.emit(this.nameEventClose, null);
  }

  save() {
    logService.Info("Inicio","SorteoFiltrosPopup.vue - save()");
    eventService.emit(this.nameEventSave, this.filtro);
  }

  eliminarFiltros() {
    logService.Info("Inicio","SorteoFiltrosPopup.vue - eliminarFiltros()");
    this.visibleConfirm = true;
  }

  checkSelected(cifra: string, index: any){
    return (cifra !== null && cifra !== undefined) ? cifra.search(index+"") !== -1 : false;
  }

  selected(cifra: string, valor: string, index: number){
    let tempValor = "";
    if(this.checkSelected(valor, index)){
      tempValor = valor.replace(index+"", "");
    }else{
      tempValor = valor+index+"";
    }

    switch (cifra) {
      case "1":
        this.filtro.PrimeraCifra = tempValor;
        break;
      case "2":
        this.filtro.SegundaCifra = tempValor;
        break;
      case "3":
        this.filtro.TerceraCifra = tempValor;
        break;
      case "4":
        this.filtro.CuartaCifra = tempValor;
        break;
      case "5":
        this.filtro.QuintaCifra = tempValor;
        break;
    }
  }

  changeMostrarPrimeroMayorStock(){
    this.filtro.MostrarPrimeroMenorStock = this.filtro.MostrarPrimeroMenorStock ? !this.filtro.MostrarPrimeroMayorStock : false;
  }

  changeMostrarPrimeroMenorStock(){
    this.filtro.MostrarPrimeroMayorStock = this.filtro.MostrarPrimeroMayorStock ? !this.filtro.MostrarPrimeroMenorStock : false;
  }

  changeTresOMasIguales(){
    this.filtro.NoTresOMasIguales = this.filtro.NoTresOMasIguales ? !this.filtro.TresOMasIguales : false;
  }

  changeNoTresOMasIguales(){
    this.filtro.TresOMasIguales = this.filtro.TresOMasIguales ? !this.filtro.NoTresOMasIguales : false;
  }
}
